var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"completion"},[_c('img',{staticClass:"img",attrs:{"src":"https://staticwecom.beautyfarm.com.cn/20251126/completion.png","alt":""}}),_c('div',{staticClass:"tip"},[_vm._v("审核成功，报告正在生成中")]),_c('div',{staticClass:"btn",on:{"click":_vm.toHistory}},[_vm._v("查看历史报告")])])
}
var staticRenderFns = []

export { render, staticRenderFns }